// extracted by mini-css-extract-plugin
module.exports = {"slideIn":"G9F-Kg"};